import BaseApi from "./baseApi";

export default class DeliveryTimeApi extends BaseApi {
    async getDataAsync(): Promise<Deliveries> {
        const url = `/api/deliverytime`;
        return await this.fetchGet(url);
    }
}
